import { render } from "./Messenger.vue?vue&type=template&id=3e43203d&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"

import "./Messenger.vue?vue&type=style&index=0&id=3e43203d&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e43203d"]])

export default __exports__